import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/mobile-images/home-tap-image.jpg'


const _withScopeId = n => (_pushScopeId("data-v-1eb8555e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tap1-image-animation",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { class: "tit" }
const _hoisted_4 = { class: "con" }
const _hoisted_5 = {
  key: 0,
  class: "info"
}
const _hoisted_6 = {
  key: 1,
  class: "info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, null, -1))
const _hoisted_8 = ["textContent"]

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileTab1',
  setup(__props) {

const isShowMore = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("home.tap1_button_text1")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("home.core_funs_contents1_top")), 1),
      (isShowMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("home.core_funs_contents1_center")), 1))
        : _createCommentVNode("", true),
      (isShowMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("home.core_funs_contents1_bom")), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "more",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowMore.value = !isShowMore.value))
    }, [
      _hoisted_7,
      _createElementVNode("span", {
        textContent: _toDisplayString(isShowMore.value ? _ctx.$t('home.tap_up') : _ctx.$t('home.tap_more'))
      }, null, 8, _hoisted_8)
    ])
  ], 64))
}
}

})